import { render, staticRenderFns } from "./StatusSelector.vue?vue&type=template&id=4a5c3177&scoped=true&"
import script from "./StatusSelector.vue?vue&type=script&lang=ts&"
export * from "./StatusSelector.vue?vue&type=script&lang=ts&"
import style0 from "./StatusSelector.vue?vue&type=style&index=0&id=4a5c3177&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5c3177",
  null
  
)

component.options.__file = "StatusSelector.vue"
export default component.exports